import './styles/index.css';
import { consoleVersion, erudaConsole, reportWebVitals } from './utils/dev.ts';
import i18n from './utils/i18n.ts';
import App from '@/client/app.tsx';
import { IS_DEBUG, SENTRY_DSN } from '@/client/confs/app.ts';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import 'virtual:uno.css';

/**
 * Initialize application
 */
async function initApp() {
  // Render the app
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );

  // Initialize other services
  // add sentry (lazy-loaded to reduce initial bundle)
  if (SENTRY_DSN) {
    import('@sentry/react').then(({ init, browserTracingIntegration, replayIntegration }) => {
      init({
        dsn: SENTRY_DSN,
        sendDefaultPii: true,
        integrations: [browserTracingIntegration(), replayIntegration()],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [import.meta.env.VITE_SITE_URL, new RegExp(`^${import.meta.env.VITE_API_URL}`)],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
      });
    });
  }
  if (IS_DEBUG) {
    erudaConsole();
    reportWebVitals(result => console.log(result.name, ':', result.value));
  }
  // Ensure language resources are loaded
  await i18n.loadNamespaces('translation').catch(() => {});
  consoleVersion(IS_DEBUG ? '1.0.0' : '1.0.0', i18n.t('title', { fallbackLng: 'en' })); // TODO version
}

// Initialize the application
initApp();
